import React from 'react';

type Wrapper = (children: React.ReactNode, key: number) => React.ReactNode;

const defaultWrap: Wrapper = (children, key) => <em key={key}>{children}</em>;

/**
 * Parse `*word*` markdown into wrapped React nodes. Default wrapper is
 * `<em>`. Themes pass their own wrapper to render with a class or
 * different element (warm = em.warm-em, utility-headline = span.util-underline,
 * utility-cta = span.text-accent). A pair of unmatched asterisks renders
 * the literal asterisks.
 */
export function parseEm(text: string, wrap: Wrapper = defaultWrap): React.ReactNode[] {
  const out: React.ReactNode[] = [];
  const re = /\*([^*\n]+)\*/g;
  let last = 0;
  let m: RegExpExecArray | null;
  let key = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(wrap(m[1], key++));
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out.length > 0 ? out : [text];
}

/** Default-wrapped variant — alias kept for the editorial consumers. */
export const inlineEm = (text: string) => parseEm(text);
